import getUTCDate from "@/helpers/dates/getUTCDate";

export default {
  getUTCDate,
};
